export default __webpack_public_path__ + "static/media/image54.bd5c365b.png";